import React from 'react';
import styled from 'styled-components';

// 스타일 컴포넌트
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #ededed;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  font-size: 20px;
  color: #999;
`;

const ModalBody = styled.div`
  padding: 20px;
`;

const InfoTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: center;
`;

const InfoDescription = styled.div`
  font-size: 14px;
  color: #666;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.5;
`;

const InfoSection = styled.div`
  margin-bottom: 20px;
`;

const InfoLabel = styled.div`
  font-size: 14px;
  color: #2282e9;
  margin-bottom: 8px;
`;

const InfoValue = styled.div`
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
`;

const InfoNote = styled.div`
  font-size: 12px;
  color: #999;
`;


const ConfirmButton = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 50px;
  background-color: #2282e9;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
`;

const CopyButton = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 5px;
  background-color: #2282e9;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
`;

const InfoContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  background-color: #F8F8F8;
  border-radius: 10px;
`;

const NoteList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const NoteTitle = styled.li`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: center;
`;

const NoteItem = styled.li`
  font-size: 14px;
  color: #666;
  text-align: center;
  margin-bottom: 5px;
`;

interface AccountInfoModalProps {
  onClose: () => void;
  onConfirm: () => void;
  amount: string;
  rechargeInfo: any; // 타입을 any로 변경하여 유연하게 대응
}

const AccountInfoModal: React.FC<AccountInfoModalProps> = ({
  onClose,
  onConfirm,
  amount,
  rechargeInfo
}) => {
  // rechargeInfo가 없는 경우 기본값 제공
  const defaultInfo = {
    bankAccountInfo: {
      bankName: "신한은행",
      accountNumber: "140-013-985170",
      accountOwner: "(주)플리더스 임찬영"
    },
    amount: amount ? parseInt(amount) : 0,
    depositDeadline: "2025-03-28 23:59:59"
  };

  // rechargeInfo가 없거나 구조가 다른 경우 기본값 사용
  console.log('rechargeInfo: ',rechargeInfo);
  // const safeRechargeInfo = rechargeInfo;
  
  const bankInfo = rechargeInfo?.bankAccountInfo;
  
  // 금액 형식화 함수
  const formatAmount = (amount: number | string) => {
    if (typeof amount === 'string') {
      amount = parseInt(amount);
    }
    return amount.toLocaleString();
  };

  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>플리머니 충전</ModalTitle>
          <CloseIcon onClick={onClose}>✕</CloseIcon>
        </ModalHeader>
        <ModalBody>
          <div style={{textAlign: "center", fontSize: "18px", fontWeight: "500", marginBottom: "10px", marginTop: "20px"}}>
            충전 내용 <br/><br/>
          </div>

          <div style={{textAlign: "center", fontSize: "14px", marginBottom: "20px", lineHeight: "1.5"}}>
          아래의 계좌번호로 입금해주시면<br/>
          정상적으로 결제 완료처리가 됩니다.
          </div>
          <InfoContainer>
            <InfoSection>
              <InfoLabel>계좌 정보</InfoLabel>
              <InfoValue>{bankInfo?.bankName} {bankInfo?.accountNumber}</InfoValue>
              <InfoValue>예금주: {bankInfo?.accountOwner}</InfoValue>
            </InfoSection>
            
            <InfoSection>
              <InfoLabel>결제 금액</InfoLabel>
              <InfoValue>{rechargeInfo?.amount.toLocaleString()}원</InfoValue>
            </InfoSection>
            
    
            
            <InfoSection>
              <InfoLabel>입금기한</InfoLabel>
              <InfoValue>{rechargeInfo.depositDeadline || defaultInfo.depositDeadline}</InfoValue>
              <InfoNote>(기한내 미 입금시 자동 취소 됩니다.)</InfoNote>
            </InfoSection>
          </InfoContainer>
          
          <ConfirmButton onClick={onConfirm}>
            확인
          </ConfirmButton>
        </ModalBody>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default AccountInfoModal; 